export default function initCustomerSwitch(): void {
  Alpine.data("customerSwitch", () => ({
    init() {
      this.$refs.customerSwitchPopup.addEventListener("command", (e) => {
        // @ts-expect-error tailwindcss component
        if (e.command === "show-modal") {
          (this.$refs.search as HTMLInputElement).value = "";
          this.$refs.customerList.textContent = "";
          this.$refs.notInitiated.classList.toggle("tw:block");
          this.$refs.noResults.classList.add("tw:hidden");
          this.$refs.loading.classList.add("tw:hidden");
        }
      });

      this.$refs.customerSwitchPopup.addEventListener("close", () => {
        (this.$refs.search as HTMLInputElement).value = "";
        this.$refs.customerList.textContent = "";
        this.$refs.notInitiated.classList.remove("tw:hidden");
        this.$refs.noResults.classList.add("tw:hidden");
        this.$refs.loading.classList.add("tw:hidden");
      });

      const customerListTemplate = Hogan.compile(
        this.$refs.customerListTemplate.textContent,
      );
      const searchFrom = this.$refs.customerSearchForm as HTMLFormElement;
      searchFrom.addEventListener("submit", (e: SubmitEvent) => {
        e.preventDefault();
        this.$refs.customerList.textContent = "";
        this.$refs.notInitiated.classList.add("tw:hidden");
        this.$refs.noResults.classList.add("tw:hidden");
        this.$refs.loading.classList.remove("tw:hidden");

        const { action } = searchFrom;
        if (action) {
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          fetch(`?${serialize(searchFrom)}`)
            .then(async (res) => res.json())
            .then((data) => {
              this.$refs.loading.classList.add("tw:hidden");
              if (!data.customers || data.customers.length === 0) {
                this.$refs.noResults.classList.remove("tw:hidden");
              } else {
                this.$refs.customerList.innerHTML = customerListTemplate.render(
                  {
                    customers: data.customers,
                  },
                );
              }
            });
        }
      });
    },
  }));
}

/*!
 * Serialize all form data into a query string
 * (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
 * @param  {Node}   form The form to serialize
 * @return {String}      The serialized form data
 */
let serialize = (form: HTMLFormElement): string => {
  const serialized: string[] = [];

  // eslint-disable-next-line no-restricted-syntax
  for (const element of form.elements) {
    const field = element as HTMLInputElement | HTMLSelectElement;

    if (
      !field.name ||
      field.disabled ||
      field.type === "file" ||
      field.type === "reset" ||
      field.type === "button"
    )
      continue; // eslint-disable-line no-continue

    if (
      field instanceof HTMLSelectElement &&
      field.type === "select-multiple"
    ) {
      // eslint-disable-next-line no-restricted-syntax
      for (const option of field.options) {
        if (option.selected) {
          serialized.push(
            `${encodeURIComponent(field.name)}=${encodeURIComponent(option.value)}`,
          );
        }
      }
    } else if (
      (field.type !== "checkbox" && field.type !== "radio") ||
      field.checked
    ) {
      serialized.push(
        `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`,
      );
    }
  }

  return serialized.join("&");
};
